import { createActions } from 'redux-actions';
import { GET_LOGOUT_REASON, GET_LOGOUT_REASON_DETAIL } from '../actionTypes';

export default createActions({
  [GET_LOGOUT_REASON]: state => {
    return state;
  },
  [GET_LOGOUT_REASON_DETAIL]: state => {
    return state;
  }
});
